export enum TariffType {
  Trial = 'Trial',
  PerActualData = 'PerActualData',
  PerData = 'PerData',
  PerDomain = 'PerDomain',
  PerOnOrHaveDataUsers = 'PerOnOrHaveDataUsers',
  PerHaveDataUsers = 'PerHaveDataUsers',
  PerUser = 'PerUser'
}
